module.exports = __webpack_public_path__ + "img/avatar3.78e854a3.png";